import type { IconProps } from './types';
import './icons.css';

export default function ChangeLogClock({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-change-log-clock ${className || ''}`}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.7 5.75a.75.75 0 0 0 .197 0H5a.75.75 0 0 0 0-1.5h-.675A5.25 5.25 0 1 1 2.75 8a.75.75 0 0 0-1.5 0 6.75 6.75 0 1 0 2.167-4.955v-.378a.75.75 0 1 0-1.5 0V5c0 .414.335.75.75.75H2.7ZM8 4.25a.75.75 0 0 1 .75.75v2.917h1.583a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75V5A.75.75 0 0 1 8 4.25Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
